// const API_BASE_URL = 'http://localhost:5000';
// const API_BASE_URL = 'https://quotation-manegement-backend.vercel.app';
const API_BASE_URL = 'https://quotation-management-backend.onrender.com';



export { API_BASE_URL };
